module.exports = __webpack_public_path__ + "img/icon-project-manager.6ad56f8d.svg";